<template>
  <div class="terms">
    <b-container>
      <b-row class>
      
        <b-col md="12" sm="12">
          <p class="text text-justify paragraphs" v-for="(para,index) in paragraphs" :key="index">{{para}}</p>
        </b-col>
        <Titlepara v-for="(par,index) in paras" :key="index" :para="par" />
        <!-- Merchant Agreement Section -->
        <b-col md="12" sm="12">
          <h4 class="heading">Merchant Agreement</h4>
          <div>
            <ul class="litext">
              <div class="textMercant text-justify">
                Please visit the 
                <a :href="pdfLink" target="_blank" class="link text-decoration-none">
                  Merchant Agreement
                </a> 
                for more information.
              </div>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Titlepara from "../common/title-para";
export default {

  name: "Terms",
  props: ["paragraphs", "paras"],
  components: {
    Titlepara,
  },
  data() {
    return {
     
      pdfLink: 'https://d3ba6ur3jzoh9w.cloudfront.net/losdocs/Merchant_Payment_Gateway_Agreement.pdf'

    };
  },
};
</script>
<style scoped>
.card1 {
  border-radius: 20px;
}
.litext{
  color: #1f3c6f;
   font-weight: 600;
}
.textMercant {
  color:var(--mainBlueColor);
  font-size: 16px;
  font-weight: 500;
  text-align: justify;
  /*  text-indent: 1.25rem; */
}
.heading {
  color: var(--mainBlueColor);
  background: transparent;
  border: none;
  margin-bottom: 1.25rem;
  margin-top: 1.25rem;
  text-align: left;
}
.title {
  color: #2a4b7c;
  background: transparent;
  border: none;
  margin-bottom: 1.25rem;
  margin-top: 2rem;
  text-align: center;
  text-decoration: underline;
}
.heading {
  color: #2a4b7c;
  background: transparent;
  border: none;
  margin-bottom: 1.25rem;
  margin-top: 1.25rem;
}
.sub-heading {
  color: #2a4b7c;
  background: transparent;
  border: none;
  text-indent: 1.25rem;
}
.text {
  color: #2a4b7c;
  font-size: 16px;
  font-weight: 500;
  /* text-indent: 1.25rem; */
}
li::marker {
  color: #e7242a;
  font-weight: 600;
}

@media (max-width: 767px) {
  .text {
    font-size: 0.75rem;
  }
}
</style>